import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useContext, useState, use } from "react";
import React from "react";
import { DataHandlerContext } from "../../providers/DataHandlerProvider";
import { DataContext } from "../../providers/DataProvider";
import DeleteModal from "../modal/DeleteModal";
import AddFileModal from "../modal/AddFileModal";
import DisplayRecordsCard from "../DisplayRecordsCard";
import BackButton from "../buttons/BackButton";
import ModifyFormButton from "../buttons/ModifyFormButton";

function MarkFormCard({}) {

  const [deletingId, setDeletingId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] =
    useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { formid } = useParams();

  const {
    handlePopulateEachMarkForm,
    populateEachMarkForm,
    setListOfMarkFormSubmissions,
    listOfMarkFormSubmissions,
    setMarkFormObject,
  } = useContext(DataContext);

  const { handleDeleteMarkForm } = useContext(DataHandlerContext);

  const handleSettingDeleteId = (value, id) => {
    setShowDeleteModal(value);
    setDeletingId(id);
  };

// Function to handle the deletion of the mark form
  const deleteMarkForm = async (confirmDelete) => {
    setShowDeleteModal(false);
    if (confirmDelete) {
      try {
        const response = await handleDeleteMarkForm(deletingId);
        if (response.status === 200) {
          console.log("Mark Form Deleted");
          setMarkFormObject((prevState) =>
            prevState.filter((markForm) => markForm.id !== deletingId)
          );
         
          navigate(-1);
        }
      } catch (error) {
        console.log("Error:", error);
      }
    }
  };

  useEffect(() => {
    handlePopulateEachMarkForm(formid);
  }, [listOfMarkFormSubmissions]);

  return (
    <div className="flex flex-col min-h-screen bg-neutral-100">
      
      <div className="flex flex-col md:flex-row md:justify-between md:items-center lg:px-[10rem] p-[2rem] py-10 md:py-20 gap-6 md:gap-0">
        
        <div>
          <BackButton 
            newLocation={`/home`}
            
          />
        </div>
        
        
        <div className="flex flex-col md:flex-row gap-4">
          <button
            className="px-4 py-2 bg-slate-700 text-white rounded-lg text-lg hover:shadow-lg flex gap-1 items-center w-full sm:w-auto"
            onClick={() => navigate("view")}
          >
            <svg
              className="w-8 h-8"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 100 100"
            >
              <path d="m92.105 47.961c-10.535-13.711-24.426-21.535-39.355-22.426-1.5625-0.16406-3.918-0.16797-5.5 0-14.93 0.89453-28.82 8.7148-39.355 22.43-1 1.2852-1 3.0703 0 4.3555 10.535 13.57 24.465 21.285 39.395 22.145 1.3477 0.14844 3.6523 0.19141 5.4648 0 14.93-0.85547 28.82-8.5703 39.355-22.145 0.99609-1.2852 0.99609-3.0703-0.003906-4.3594zm-42.105 19.5c-9.6445 0-17.465-7.8203-17.465-17.465 0-9.6445 7.8203-17.465 17.465-17.465s17.465 7.8203 17.465 17.465c0 9.6445-7.8203 17.465-17.465 17.465z" />
              <path d="m55.82 55.785c-3.3555 3.1445-8.3203 3.1445-11.645 0-1.8203-1.9297-2.6055-4.3945-2.2852-6.7852 0.75 0.5 1.6445 0.75 2.6055 0.75 2.8555 0 5.1445-2.3203 5.1445-5.1445 0-0.96484-0.28516-1.8945-0.75-2.6445 2.4648-0.28516 5.1055 0.42969 6.9297 2.2148 3.1445 3.3242 3.1445 8.2852 0 11.609z" />
            </svg>
            <span>Form</span>
          </button>
          {showDeleteModal && (
        <DeleteModal
          text={"Are you sure you want to delete this form?"}
          funct={deleteMarkForm}
        />
      )}

          <button
            onClick={(e) => handleSettingDeleteId(true, populateEachMarkForm.id)}
            className="rounded-lg text-lg hover:shadow-lg px-4 py-2 bg-red-300 text-red-700 flex gap-1 items-center justify-center w-full sm:w-auto"
          >
            <svg
              className="h-5   md:h-6 md:w-6"
              viewBox="0 0 100 100"
              fill="currentColor"
            >
              <path d="m50.094 8c-3.7031 0-6.4258 1.4609-8.2812 2.875s-3.0039 2.5742-4.9375 3.3438c-0.84766 0.27734-1.5547 0.94922-1.875 1.7812h-18v6h66v-6h-18c-0.32031-0.83203-1.0273-1.5078-1.875-1.7812-1.9531-0.77734-3.168-1.9453-5-3.3438s-4.4766-2.875-8.0312-2.875zm0 6c2.207 0.125 3.4531 0.93359 4.8438 2h-9.9375c1.7539-1.3516 3.5898-1.9844 5.0938-2zm-30.094 10v56.031c0 3.4922 0.91016 6.6406 3.125 8.8438s5.3867 3.125 8.9062 3.125h36c3.4844 0 6.6445-0.92188 8.8438-3.125s3.125-5.3516 3.125-8.8438v-56.031h-60z" />
            </svg>
            <span>Delete</span>
          </button>

          <button
            className="px-4 py-2 bg-slate-500 text-white rounded-lg text-lg hover:shadow-lg flex gap-1 items-center w-full sm:w-auto"
            onClick={() => navigate("edit")}
          >
            <svg
              version="1.1"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="w-6 h-6"
            >
              <g>
                <path d="m91.668 24.594-16.262-16.262-11.266 11.27 16.258 16.258z" />
                <path d="m25 75 17.887-1.625 30.777-30.781-16.258-16.258-30.781 30.777z" />
                <path
                  d="m62.5 91.668h-54.168v-8.3359h54.168z"
                  fillRule="evenodd"
                />
              </g>
            </svg>
            <span>Edit</span>
          </button>
          <ModifyFormButton />
        </div>
      </div>
      
     
      <div className="flex  justify-between lg:px-[10rem] p-[2rem] pt-0 md:pt-0 items-center md:space-x-4">
        <h1 className="text-4xl md:text-5xl font-extrabold break-words">
          {populateEachMarkForm.title}
        </h1>
      </div>

 
      <div className="flex flex-col md:flex-col justify-between px-4 lg:px-[10rem] items-center md:gap-4">
        <DisplayRecordsCard
          type="markform"
          formId={populateEachMarkForm.id}
          event_title={populateEachMarkForm.title}
          listOfUserSubmissions={populateEachMarkForm.submissions}
          setMarkFormSubmissions={setListOfMarkFormSubmissions}
          totalAttendees={Object(populateEachMarkForm.submissions).length}
        />
      </div>
    </div>
  );
}

export default MarkFormCard;